/** Shared Tailwind classes for package builder tabs (admin + supplier). */

export const pbSectionCard =
  "rounded-xl border border-gray-200/60 bg-white shadow-sm";

export const pbInnerSection =
  "rounded-xl border border-gray-200/80 bg-white p-4 sm:p-5 shadow-sm";

export const pbHotelPanel =
  "mt-5 rounded-xl border border-gray-100 bg-slate-50/60 p-4 sm:p-5";

export const pbHotelCard =
  "rounded-lg border border-gray-200/80 bg-white p-4 shadow-sm";

export const pbItemCardShell =
  "rounded-xl border border-gray-200/80 bg-white shadow-sm";

export const pbItemCard =
  "rounded-xl border border-gray-200/80 bg-white p-4 shadow-sm";

export const pbIndexBadge =
  "flex h-8 w-8 shrink-0 items-center justify-center rounded-lg border border-gray-200 bg-white text-xs font-semibold text-gray-700 shadow-sm";

export const pbStayIndexBadge =
  "flex h-9 w-9 shrink-0 items-center justify-center rounded-xl bg-gray-900 text-sm font-semibold text-white shadow-sm";

export const pbHotelCountBadge =
  "inline-flex h-6 min-w-6 items-center justify-center rounded-full bg-gray-900 px-2 text-[11px] font-semibold text-white";

export const pbIndexBadgeSm =
  "flex h-6 w-6 items-center justify-center rounded-md border border-gray-200 bg-slate-50 text-xs font-semibold text-gray-600";

export const pbDeleteBtn =
  "flex h-8 w-8 shrink-0 items-center justify-center rounded-lg border border-red-100 bg-red-50 text-red-500 transition hover:border-red-200 hover:bg-red-100";

export const pbDeleteBtnDisabled =
  "disabled:cursor-not-allowed disabled:opacity-50";

export const pbAddBtn =
  "inline-flex items-center justify-center gap-2 rounded-lg border border-gray-200 bg-white px-4 py-2.5 text-sm font-medium text-gray-700 transition hover:border-gray-300 hover:bg-gray-50";

export const pbAddBtnFull =
  "flex w-full items-center justify-center gap-2 rounded-lg border border-gray-200 bg-white px-4 py-2.5 text-sm font-medium text-gray-700 transition hover:border-gray-300 hover:bg-gray-50";

export const pbAddBtnMt =
  "mt-4 flex w-full items-center justify-center gap-2 rounded-lg border border-gray-200 bg-white px-4 py-2.5 text-sm font-medium text-gray-700 transition hover:border-gray-300 hover:bg-gray-50";

export const pbSectionTitle = "text-sm font-bold text-gray-900";

export const pbSectionSubtitle = "mt-0.5 text-xs text-gray-500";

export const pbFieldLabel =
  "mb-1.5 block text-xs font-medium text-gray-600";

export const pbFieldInput =
  "w-full rounded-lg border border-gray-200 px-3 py-2 text-sm font-medium text-gray-800 placeholder:text-sm placeholder:font-normal placeholder:text-gray-400 focus:border-primary focus:outline-none focus:ring-1 focus:ring-primary/20";

export const pbListFieldInput =
  "flex-1 rounded-lg border border-gray-200 px-3 py-2 text-sm font-medium text-gray-800 placeholder:font-normal placeholder:text-gray-400 focus:border-primary focus:outline-none focus:ring-1 focus:ring-primary/20";

export const pbEmptyState =
  "rounded-xl border border-gray-100 bg-slate-50/40 px-4 py-6 text-sm text-gray-600";

export const pbEditorWrap =
  "overflow-hidden rounded-xl border border-gray-200/60 bg-white shadow-sm";
